import { getParameterFromURL } from './getParameterFromURL';
export function setGenericParameter(afParams, oneLinkParam, searchKey) {
  var newParamValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var searchKeyResult = getParameterFromURL(searchKey);

  if (searchKeyResult) {
    afParams[oneLinkParam] = searchKeyResult;
  } else {
    if (newParamValue !== null) {
      afParams[oneLinkParam] = newParamValue;
    }
  }
}